import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type { CreateChatMessageArgs } from "../types"
import type { JSONValue } from "@rocicorp/zero"

export const chatMessageMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateChatMessageArgs
			ctx: ZeroJwtPayload
		}) => {
			const now = Date.now()

			await tx.mutate.chatMessages.insert({
				id: args.id,
				createdAt: now,
				updatedAt: now,
				isDeleted: false,
				type: args.type,
				platform: args.platform,
				platformMessageId: `outbound-${now}`,
				chatThreadId: args.chatThreadId,
				authorName: null,
				authorId: null,
				text: args.text,
				html: args.html,
				attachments: (args.attachments ?? []) as unknown as JSONValue,
				workspaceId: authData.workspaceId,
				threadId: args.threadId,
				userId: args.userId,
			})

			await tx.mutate.feedbacks.update({
				id: args.threadId,
				lastOutboundMessageAt: now,
				lastMessageAt: now,
				replied: true,
			})
		},
	),
}
